export default __webpack_public_path__ + "static/accents-mixing-colors-dont-light-bd65868c43a927bf3d465078ae6c9ff9b58f5d6cef106ae252512f179bb9308c.png";